module.exports = __webpack_public_path__ + "img/close-dropdown-icon.75e2bc68.svg";